@if (
  !hasSkippedGroupJoining && (!groupMemberships || groupMemberships.length <= 0)) {
  <div
    >
    <h1 class="page-title">Welcome to Me and My Planet</h1>
    <div class="single-app-card">
      <app-card title="Join a Group">
        <p>
          You can join a group by entering the code below. If you don’t have it
          yet, don’t worry, you can join later in your settings!
        </p>
        <!-- Join group by code -->
        <form [formGroup]="groupCodeForm">
          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>Group Code</mat-label>
              <input matInput formControlName="groupCode" required />
            </mat-form-field>
          </div>
          <strong>Not sure where to find your code?</strong>
          <p>
            Your professor will send you a code to join the group. If you haven't
            received it yet, please contact them for assistance.
          </p>
          <div class="form-actions">
            <button
              class="btn"
              [disabled]="groupCodeForm.invalid"
              (click)="onSubmitGroupCode()"
              >
              <app-icon name="groups"></app-icon>
              Join group
            </button>
            <button class="btn btn-decline" (click)="onSkipGroupJoining()">
              <app-icon name="skip" color="black"></app-icon>
              Skip for now
            </button>
          </div>
        </form>
      </app-card>
    </div>
  </div>
} @else {
  <h1 class="page-title">Dashboard</h1>
  <div class="grid-container">
    <!--Daily Logs-->
    <app-card>
      <div class="card-title">
        <app-icon [name]="'calendar'" color="black"></app-icon>
        <h3>Daily Logs</h3>
      </div>
      <div class="dashboard-daily-overview">
        <div class="date-selection-button-container">
          @for (date of displayedDates; track date) {
            <div>
              <button
                (click)="onDateSelected(date)"
                class="date-select-btn"
              [ngClass]="{
                'filled': hasEntries(date),
                'today': isToday(date),
                'in-group-time-period': isInGroupTimePeriod(date, groupMemberships),
                'disabled': isInFuture(date)
              }"
                [disabled]="isInFuture(date)"
              [matTooltip]="
                isInFuture(date)
                  ? 'Cannot select future dates'
                  : (date | date : 'dd.MM.yyyy')
              "
                [matTooltipPosition]="'above'"
                >
                <div class="date-display">
                  <span class="date-select-btn-day">{{
                    date | date : "dd."
                  }}</span>
                  <span class="date-select-btn-month">{{
                    date | date : "MMM"
                  }}</span>
                </div>
              </button>
            </div>
          }
        </div>
        <button class="btn" (click)="onDateSelected(null)">
          Track emissions for today
        </button>
      </div>
    </app-card>
    <!--General Emissions-->
    <app-card class="single-app-card">
      <div class="card-title">
        <app-icon name='house_plugged' color="black"></app-icon>
        <h3>General Emissions</h3>
      </div>
      <div class="dashboard-baseline-overview">
        <div class="baseline-category-list">
          @for (category of categories; track category) {
            <div
              class="baseline-category-item"
              >
              <div class="category-info">
                <div class="category-header">
                  <span class="category-name">{{ category.text.text_en }}</span>
                </div>
                <app-progress-bar
                  [progress]="getProgressForCategory(category.id)"
                  [color]="'#4caf50'"
                  />
              </div>
            </div>
          }
          <div class="baseline-category-item">
            <div class="category-info">
              <div class="category-header">
                <span class="category-name">Digitalization</span>
              </div>
              <app-progress-bar
                [progress]="getDigitalizationProgress()"
                [color]="'#4caf50'"
                />
            </div>
          </div>
        </div>
        <button class="btn" routerLink="/logs/general">
          {{ getGeneralLogsButtonLabel() }}
        </button>
      </div>
    </app-card>
    <!--Today's Emissions-->
    <app-card>
      <div class="card-title">
        <app-icon [name]="'chart_bar_column'" color="black"></app-icon>
        <h3>Your CO₂ Emissions Today</h3>
      </div>
      <div class="dashboard-chart-container">
        <app-dashboard-chart></app-dashboard-chart>
      </div>
      <button class="btn" routerLink="/report">See my report</button>
    </app-card>
  </div>
}

